export default __webpack_public_path__ + "static/media/rightChevronYellowFilled.cbe94a76.svg";